import './Modal.css'

function LocationModal({ open, onClose, location, longitude, city, country }) {
  if (!open) return null;

  const lat = Number(location);
  const lng = Number(longitude);

  const hasValidCoords =
    !isNaN(lat) &&
    !isNaN(lng) &&
    lat !== 0 &&
    lng !== 0;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalBox" onClick={(e) => e.stopPropagation()}>
        <h3>Login Location</h3>

        <p>
          📍 {city || "Unknown City"}, {country || "Unknown Country"}
        </p>

        {hasValidCoords ? (
          <iframe
            title="map"
            width="100%"
            height="260"
            style={{ border: 0, borderRadius: 10 }}
            loading="lazy"
            allowFullScreen
            src={`https://maps.google.com/maps?q=${lat},${lng}&z=15&output=embed`}
          />
        ) : (
          <p style={{ color: "red" }}>
            ❌ Invalid location coordinates
          </p>
        )}

        <button onClick={onClose} className="closeBtn">
          Close
        </button>
      </div>
    </div>
  );
}





export default LocationModal